import { notifyParent } from 'mailup-react-helpers'

export const openMshopEngagementReports = (): void => {
  notifyParent('redirectMainFrame', [
    'mshop_redirector.aspx?t=mshopproddet&cp=EngagementReport',
  ])
}

export const openMshopEngagementFilters = (): void => {
  notifyParent('redirectMainFrame', [
    'mshop_redirector.aspx?t=mshopproddet&cp=EngagementFilters',
  ])
}

export const getEngagementDocumentationURL = (lang: string): string => {
  switch (lang) {
    case 'it':
      return 'https://mailup.it/blogs/misurare-engagement/'
    case 'es':
      return 'https://mailup.es/blogs/medir-el-compromiso/'
    default:
      return 'https://mailup.com/blogs/measure-engagement/'
  }
}
